import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './core/services/auth-guard.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EventComponent } from './event/event.component';
import { LoginComponent } from './login/login.component';
import { MailTemplateComponent } from './mail-template/mail-template.component';
import { ShipmentComponent } from './shipment/shipment.component';
import { DocumentsComponent } from "./documents/documents.component";
import { AdminRoleGuardService } from './core/services/admin-role-guard.service';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService] },
  { path: 'event', component: EventComponent, canActivate: [AuthGuardService] },
  { path: 'mail-template/:code', component: MailTemplateComponent, canActivate: [AuthGuardService, AdminRoleGuardService] },
  { path: 'login', component: LoginComponent },
  { path: 'adfs/:token', component: LoginComponent },
  { path: 'revenue', component: ShipmentComponent, canActivate: [AuthGuardService] },
  { path: 'shipment', component: ShipmentComponent, canActivate: [AuthGuardService] },
  { path: 'help', component: DocumentsComponent, canActivate: [AuthGuardService] },
  { path: '**', redirectTo: '/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
